import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { getFormValues, reduxForm } from 'redux-form/immutable';
import { connect } from 'react-redux';

// actions
import { destroy, initialize } from 'redux-form/immutable';

// components
import { Field } from 'redux-form/immutable';
import { Button, Checkbox, DatePicker, Error } from '../../shared/_form';

// constants
const  FORM_NAME = 'doctorTooltipForm';

class DoctorTooltipForm extends React.Component {
  static propTypes = {
    doctor:     PropTypes.instanceOf(Immutable.Map),
    doctorId:   PropTypes.string,
    errors:     PropTypes.instanceOf(Immutable.Map),
    formValues: PropTypes.instanceOf(Immutable.Map),
    onClose:    PropTypes.func.isRequired,
    onSubmit:   PropTypes.func.isRequired
  }

  componentWillMount() {
    this._initForm(this.props);
  }

  componentWillUnmount() {
    this._resetForm();
  }

  render() {
    const { doctor, onClose } = this.props;

    const errors  = (doctor || Immutable.Map()).get('error') || Immutable.Map();
    const loading = doctor.get('loading') || false;

    return (
      <form onSubmit={ this._handleSubmit }>
        <div className='form__group tooltip__form__group'>
          <div className='form__group__label tooltip__form__group__label'>Name:</div>
          <div className='form__group__field tooltip__form__group__field'>
            <Field className='form__field' component='input' name='name' type='text' />
            <Error className='tooltip__form__group__error'>{ errors.get('name') }</Error>
          </div>
        </div>
        <div className='form__group tooltip__form__group'>
          <div className='form__group__label tooltip__form__group__label'>Email:</div>
          <div className='form__group__field tooltip__form__group__field'>
            <Field className='form__field' component='input' name='email' type='text' />
            <Error className='tooltip__form__group__error'>{ errors.get('email') }</Error>
          </div>
        </div>
        <div className='form__group tooltip__form__group'>
          <div className='form__group__label tooltip__form__group__label'>In Office:</div>
          <div className='form__group__field tooltip__form__group__field'>
            <Field component={ this._renderCheckbox } id='inOfficeMonday' name='inOfficeMonday' type='checkbox' /><span className='manager__doctor-index__create-doctor-tooltip__checkbox-label'>M</span>
            <Field component={ this._renderCheckbox } id='inOfficeTuesday' name='inOfficeTuesday' type='checkbox' /><span className='manager__doctor-index__create-doctor-tooltip__checkbox-label'>T</span>
            <Field component={ this._renderCheckbox } id='inOfficeWednesday' name='inOfficeWednesday' type='checkbox' /><span className='manager__doctor-index__create-doctor-tooltip__checkbox-label'>W</span>
            <Field component={ this._renderCheckbox } id='inOfficeThursday' name='inOfficeThursday' type='checkbox' /><span className='manager__doctor-index__create-doctor-tooltip__checkbox-label'>R</span>
            <Field component={ this._renderCheckbox } id='inOfficeFriday' name='inOfficeFriday' type='checkbox' /><span className='manager__doctor-index__create-doctor-tooltip__checkbox-label'>F</span>
          </div>
        </div>
        <div className='form__group tooltip__form__group'>
          <div className='form__group__label tooltip__form__group__label'>Starts On:</div>
          <div className='form__group__field tooltip__form__group__field'>
            <Field className='manager__doctor-index__create-doctor-tooltip__date-picker'
              component={ DatePicker }
              name='currentStartDate'
              type='text' />
            <Error className='tooltip__form__group__error'>{ errors.get('currentStartDate') }</Error>
          </div>
        </div>

        <div className='form__submit'>
          <Button className='form__button form__button--purple' disabled={ loading } onClick={ onClose } type='button'>Cancel</Button>
          <Button className='form__button form__button--green' loading={ loading } type='submit'>Save</Button>
        </div>
      </form>
    );
  }

  // private

  _handleSubmit   = this._handleSubmit.bind(this);
  _renderCheckbox = this._renderCheckbox.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const { formValues, onSubmit } = this.props;

    if (!formValues) {
      return;
    }

    const values = formValues.withMutations((map) => {
      map.set('inOfficeMonday', map.get('inOfficeMonday') === true);
      map.set('inOfficeTuesday', map.get('inOfficeTuesday') === true);
      map.set('inOfficeWednesday', map.get('inOfficeWednesday') === true);
      map.set('inOfficeThursday', map.get('inOfficeThursday') === true);
      map.set('inOfficeFriday', map.get('inOfficeFriday') === true);
    });

    onSubmit((values || Immutable.Map()).toJS());
  }

  _initForm(props) {
    const { doctorId } = this.props;

    const data = (props.doctor.get('data') || Immutable.Map()).get(doctorId);

    if (data) {
      const doctor = data.withMutations((map) => {
        const currentWeeklySchedule = map.get('currentWeeklySchedule') || Immutable.Map();

        map.set('inOfficeMonday', currentWeeklySchedule.get('monday'));
        map.set('inOfficeTuesday', currentWeeklySchedule.get('tuesday'));
        map.set('inOfficeWednesday', currentWeeklySchedule.get('wednesday'));
        map.set('inOfficeThursday', currentWeeklySchedule.get('thursday'));
        map.set('inOfficeFriday', currentWeeklySchedule.get('friday'));
      });

      props.dispatch(initialize(FORM_NAME, doctor, { keepDirty: true }));
    }
  }

  _renderCheckbox({ input, meta, ...rest }) {
    const value         = typeof input.value === 'boolean' ? input.value : false,
          _handleChange = input.onChange;

    return <Checkbox checked={ input.value }
      { ...input }
      { ...rest }
      onChange={ _handleChange }
      value={ value } />;
  }

  _resetForm() {
    const { dispatch } = this.props;

    dispatch(destroy(FORM_NAME));
  }
}

const mapStateToProps = (state) => {
  return {
    doctor:     state.get('doctor'),
    formValues: getFormValues(FORM_NAME)(state),
    tooltip:    state.get('tooltip')
  };
};

export default (
  connect(mapStateToProps)(
    reduxForm(
      { form: FORM_NAME }
    )(DoctorTooltipForm)
  )
);



// WEBPACK FOOTER //
// ./app/components/managers/doctors/_DoctorTooltipForm.jsx